exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CalendarDate-7d6247ef{display:inline-block;text-align:center;border-radius:2px;overflow:hidden;color:#616161;height:70px;width:70px}.CalendarDate-7d6247ef .heading-bdb037d3{text-transform:uppercase;background:#6982FF;color:#FFF;font-size:12px;font-weight:bold;letter-spacing:3px;line-height:18px;padding:5px;height:28px}.CalendarDate-7d6247ef .date-208ece96{font-weight:500;padding:8px 10px 10px 10px;border:1px solid #E0E0E0;border-top:none;border-radius:0 0 2px 2px;font-size:13px;height:42px}.CalendarDate-7d6247ef.large-1d20fc39{height:80px;width:80px}.CalendarDate-7d6247ef.large-1d20fc39 .date-208ece96{padding-top:15px;height:52px}\n", ""]);

// Exports
exports.locals = {
	"CalendarDate": "CalendarDate-7d6247ef",
	"heading": "heading-bdb037d3",
	"date": "date-208ece96",
	"large": "large-1d20fc39"
};